import axios from 'axios';
import * as constants from './constants';

const syndicationApi = axios.create({
    baseURL: `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/syndication/`,
});

// Request Interceptor — attach investor auth token
syndicationApi.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('investorAuthToken');
        if (token) {
            config.headers.Authorization = `Token ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor — handle 401 for investor
syndicationApi.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const isInvestorRoute = window.location.pathname.startsWith('/investor');
            if (isInvestorRoute) {
                localStorage.removeItem('investorAuthToken');
                localStorage.removeItem('investorUser');
                localStorage.removeItem('activeRole');
                if (!window.location.pathname.includes('/investor/login')) {
                    window.location.href = '/investor/login';
                }
            }
        }
        return Promise.reject(error);
    }
);

export default syndicationApi;

// Founder syndication API — uses founderAuthToken
export const founderSyndicationApi = axios.create({
    baseURL: `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/syndication/`,
});

founderSyndicationApi.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('founderAuthToken');
        if (token) {
            config.headers.Authorization = `Token ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

founderSyndicationApi.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const isFounderRoute = window.location.pathname.startsWith('/founder');
            if (isFounderRoute) {
                localStorage.removeItem('founderAuthToken');
                localStorage.removeItem('founderUser');
                if (!window.location.pathname.includes('/founder/login')) {
                    window.location.href = '/founder/login';
                }
            }
        }
        return Promise.reject(error);
    }
);

// Admin syndication API — uses the main employee authToken
export const adminSyndicationApi = axios.create({
    baseURL: `${constants.HTTP_METHOD}${constants.HTTP_URL}${constants.HTTP_PORT}/api/v1/syndication/`,
});

adminSyndicationApi.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers.Authorization = `Token ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

adminSyndicationApi.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('authToken');
            localStorage.removeItem('user');
            if (!window.location.href.includes('login')) {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);
